<template>
  <div>
    <v-radio-group v-model="itemSelected" v-if="items.length > 0">
      <v-row no-gutters v-for="(item, key) in items" :key="key">
        <v-col>
          <v-text-field
              v-on:change="change"
              v-model="items[key].value"
              outlined
              hide-details
              class="my-2"
              v-on:keyup.enter="(e) => e.preventDefault()"
          ></v-text-field>
        </v-col>

        <v-col cols="1" class="action-cols" v-if="selectable">
          <v-radio class="radio-select-main" :value="key"></v-radio>
        </v-col>

        <v-col cols="1" class="action-cols remove-btn pt-4 ml-2">
          <v-btn
              color="primary"
              icon
              @click="removeOne($event, key)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-radio-group>

    <v-btn
        v-if="this.items.length < this.limit"
        small
        color="primary"
        text
        @click="addOne"
        class="mb-5"
    >
      {{ addText }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "LocationListItems",
  props: {
    limit: {
      type: Number,
      required: true
    },
    value: Array,
    selectable: Boolean,
    addText: {
      type: String,
      default: 'Adicionar'
    }
  },
  data: () => ({
    itemSelected: '',
    items: [
      { value: '', selected: false }
    ]
  }),
  methods: {
    change: function() {
      this.$emit('change', this.items)
    },
    addOne: function() {
      if (this.items.length < this.limit) {
        this.items.push({ value: '', selected: false })
      }
    },
    removeOne: function(event, index) {
      if (this.items.length > 0) {
        this.items.splice(index, 1)
      }
    }
  },
  created() {
    if (this.value) {
      this.items = this.value
    }
  },
  watch: {
    itemSelected: function(val) {
      this.items.map((item, index) => {
        item.selected = index === val
        return item
      })
      this.change()
    },
    items: function() {
      this.change()
    },
    value: function (value) {
      this.items = value
    }
  }
}
</script>

<style scoped>
  .radio-select-main {
    padding: 16px;
  }

  .remove-btn {
    padding-left: 16px;
    padding-top: 10px;
  }

  .action-cols {
    min-width: 56px
  }
</style>